import { ContainerModule, interfaces } from 'inversify';
import { ExportDataStoreImpl, IExportDataStore } from './ExportData.store';
import { ExportProjectService, IExportProjectService } from './services/ExportProject.service';

export const exportDataModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IExportDataStore.$).to(ExportDataStoreImpl).inSingletonScope();
  bind(IExportProjectService.$).to(ExportProjectService).inSingletonScope();
});
